import { ControlledMenu, MenuItem } from "@szhsin/react-menu";
import { Handle, Position } from "@xyflow/react";
import { useState } from "react";

export default function DatabaseNode(props: any) {
  const [isOpen, setOpen] = useState<any>(false);
  const [anchorPoint, setAnchorPoint] = useState<any>({ x: 0, y: 0 });

  const viewData = () => {
    props.data.onViewData();
  };

  const viewDataMap = () => {
    props.data.onEditDataMap();
  };

  return (
    <>
      <Handle type="target" position={Position.Left} />
        <div
            onContextMenu={(e) => {
                if (typeof document.hasFocus === "function" && !document.hasFocus()) return;

                e.preventDefault();
                setAnchorPoint({x: e.clientX, y: e.clientY});
                setOpen(true);
            }}>
            <img src={require("../../../../../../assets/images/hardware/database0.png")} alt="" width={150}
                 height={120}/>
            <span className="node-title">{props.data.title}</span>

            <ControlledMenu anchorPoint={anchorPoint} state={isOpen ? "open" : "closed"} direction="right"
                            onClose={() => setOpen(false)}>
                <MenuItem onClick={viewDataMap}>
                    <i className="pi pi-info me-3"></i>
                    <span>Info</span>
                </MenuItem>
                <MenuItem onClick={viewData}>
                    <i className="pi pi-database me-3"></i>
                    <span>View Data</span>
                </MenuItem>
            </ControlledMenu>
        </div>
    </>
  );
}
